import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const taggingMobile = getTagging('OTP port', 'mobile', client);

  const { trackView } = useTracking({
    event: ['checkout_step4.5'],
    event_label: 'OTP port',
    opts: taggingMobile?.opts,
    cartProduct: taggingMobile?.trackingProduct,
    pageProduct: taggingMobile?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  setTrackLink(trackView, 'OTP port');

  return null;
};

const TaggingPortabilityOtpCard = withAnimationDelay()(TaggingComponent);

export default TaggingPortabilityOtpCard;
